package streetlight.web.ui

import koala.dom.*
import streetlight.web.model.ProfileEditor

fun ViewScope.starProfileForm(model: ProfileEditor) = formColumn {
    formRow {
        imageFormSection(imageInstructions1, model.imageEditor)
        formSection("Content") {
            textField(model.taglineField, "tagline", maxLength = 50)
            centeredText("The tagline will appear under your name.")
            textEditor(model.descriptionField, "description")
            centeredText("The description will appear under the image, before your posts.")
        }
    }
}

private val imageInstructions1 = "This image will appear at the top of your profile."



